import React from 'react'
import '../styles/ModalTransition.css'

export default function ModalTransition(props) {

  return (
    <div className={ props.sty }></div>
  )
}
